<template>
  <div
    :class="[
      'faqThemeCard',
      'p-4 lg:p-8',
      'border',
      'border-gray-300',
      'rounded-2xl',
      { 'faqThemeCard-centered': props.centered },
      { 'flex flex-col items-center': props.centered },
    ]"
  >
    <div
      :class="[
        'faqThemeCard__container',
        'break-words',
        { 'faqThemeCard__container-spaceBottom': props.spaceBottom },
      ]"
    >
      <div
        :class="[
          'faqThemeCard__header',
          'flex',
          'items-center',
          'mb-6',
          { 'flex-col': props.centered },
        ]"
      >
        <RoundIcon
          :icon="icon"
          size="md"
          icon-style="circle"
          theme="dark"
          :class="[
            'faqThemeCard__header-icon',
            props.centered ? 'mb-6' : 'mr-5',
          ]"
        />
        <Heading
          :content="title"
          tag="h2"
          role="headline"
          size="medium"
          class="faqThemeCard__header-title"
        />
      </div>
      <div class="faqThemeCard__content">
        <ul :class="{ 'flex flex-col items-center': props.centered }">
          <li
            v-for="item in faqItems"
            :key="item.id || item.question"
            class="mb-3 marker:text-[var(--SysLightPrimary)]"
          >
            <a :href="item.href || '#'">{{ item.question }}</a>
          </li>
        </ul>
      </div>
    </div>

    <div class="border-t border-gray-300 pt-6">
      <BasicButton
        class="faqThemeCard__button"
        button-type="outlined"
        aria-label="Mehr"
        @click="handleButtonClick"
      >
        <SvgIcon name="arrowRight" class="mr-3.5" size="xxs" />
        Mehr
      </BasicButton>
    </div>
  </div>
</template>

<script lang="ts" setup>
import './FaqThemeCard.scss';
import Heading from 'ewi-ui/components/1-atoms/Heading';
import BasicButton from 'ewi-ui/components/1-atoms/BasicButton/BasicButton.vue';
import RoundIcon from '../RoundIcon/RoundIcon.vue';
import SvgIcon from 'ewi-ui/components/1-atoms/Icon/SvgIcon/SvgIcon.vue';

export interface FaqItem {
  id?: string;
  question: string;
  href?: string;
}

export interface FaqThemeCardProps {
  title: string;
  icon: string;
  faqItems: FaqItem[];
  centered?: boolean;
  redirectUrl?: string;
  spaceBottom?: boolean;
}

const props = withDefaults(defineProps<FaqThemeCardProps>(), {
  title: '',
  icon: 'card',
  faqItems: () => [],
  centered: false,
  redirectUrl: '',
  spaceBottom: false,
});

const handleButtonClick = () => {
  if (props.redirectUrl) {
    window.location.href = props.redirectUrl;
  }
};
</script>
